export enum MovingType {
  group,
  ungroup,
}
